import mixin from './../mixin';
import TableDeleteMultipleRowsMixin from './delete_multiple_rows_mixin';

class TableMultipleDeletable {

  constructor(wrapper_block_selector, lang) {

    this._wrapper_block = $(wrapper_block_selector);

    this._lang = lang;
  }

  get lang() {
    return this._lang;
  }

  get wrapper_block() {
    return this._wrapper_block;
  }

  get table_element() {
    return this.wrapper_block.find(this.table_selector);
  }

  init() {
    this._initSelectAllCheckbox();
    this._initDeleteSelectedRowsButton();
  }

  _submitSelectedCheckboxesForm(form) {
    form.submit();
  }
};

mixin(TableMultipleDeletable, TableDeleteMultipleRowsMixin);

export default TableMultipleDeletable;


/** WEBPACK FOOTER **
 ** ./src/common/table/multiple_deletable.js
 **/